'use strict';

function tzOffset(d) {
  return d.getTimezoneOffset();
}

module.exports = tzOffset;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/date/internal/tzOffset.js
// module id = 49
// module chunks = 1